import * as React from 'react';
import { compose, setDisplayName, withHandlers, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { ReportSettings, ReportSettingsChangeHandler } from 'logic/reports/ReportSettings';

export type OwnProps = {
    reportSettings: Readonly<ReportSettings>;
    onChange: ReportSettingsChangeHandler;
};

const RawEndRelative = ({
    endRelative,
    handleChangeEndRelative,
    t,
}: OwnProps & RecomposeProps & TranslateProps) =>
    <div>
        <label>
            <input
                type="radio"
                name="manual-data-end"
                id="manual-data-end-relative"
                checked={ endRelative }
                onChange={ handleChangeEndRelative }
            />
            { t('WC_REPORT_SCHEDULE_RELATIVE_END') }
        </label>
    </div>
;

type RecomposeProps = {
    endRelative: boolean;
    handleChangeEndRelative: React.ChangeEventHandler<HTMLInputElement>;
};

export const EndRelative = compose<OwnProps & RecomposeProps & TranslateProps, OwnProps>(
    setDisplayName('EndRelative'),
    translate(),
    withProps(({ reportSettings }: OwnProps) => ({
        endRelative: reportSettings.end < 0,
    })),
    withHandlers({
        handleChangeEndRelative: ({ onChange }: OwnProps) => (e: React.ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
                onChange(reportSettings => reportSettings.setEnd(-1));
            }
        },
    }),
)(RawEndRelative);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/dateRange/EndRelative.tsx